import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserChatComponent } from './user-chat/user-chat.component';
import { PipeModule } from "../pipes/pipe.module";
import { RouterModule, Routes } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { SideStickyBarComponent } from './side-sticky-bar/side-sticky-bar.component';
import { OffcanvasComponent } from './status-history-drawer/offcanvas/offcanvas.component';
import { UnverifiedBadgeComponent } from './unverified-badge/unverified-badge.component';
import { MatChipsModule } from '@angular/material/chips';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
  declarations: [
    UserChatComponent,
    SideStickyBarComponent,
    OffcanvasComponent,
    UnverifiedBadgeComponent
  ],
  imports: [
    CommonModule,
    PipeModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    MatIconModule
],
  exports:[
    UserChatComponent,
    SideStickyBarComponent,
    MatIconModule,
    MatChipsModule,
    MatTooltipModule,
    UserChatComponent,
    UnverifiedBadgeComponent,
    OffcanvasComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA] // Add this line to handle custom elements
})
export class SharedComponentsHelperModule { }
